import React, { ReactNode } from 'react';
import { Tooltip, IconButton, makeStyles } from 'e100-react-components';
import { useBoolState } from 'shared/hooks';

const useStyles = makeStyles(({ palette, shadows, zIndex }) => ({
  tooltip: {
    backgroundColor: palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: shadows[1],
    maxWidth: '600px',
    zIndex: zIndex.modal,
  },
}));

export const InfoButton = ({ title }: InfoButtonProps) => {
  const [open, toggleState] = useBoolState();
  const classes = useStyles();
  return (
    <Tooltip
      interactive
      title={title}
      open={open}
      placement="top"
      classes={{
        tooltip: classes.tooltip,
      }}
    >
      <IconButton kind="info" onClick={toggleState} />
    </Tooltip>
  );
};

interface InfoButtonProps {
  title: NonNullable<ReactNode | string>;
}
